
export const Urls = {
    EntityMetaData: "EntityMetaData",
    GetDynamicColumnsForEntities: "EntityMetaData/GetDynamicColumnsForEntities",
    Queries: "Queries",
    DeleteQuery: "Queries/DeleteQuery",
    QueriesAll: "Queries/all",
    CloneQuery: "Queries/Clone",
    AddQueryAssignment: "Queries/AddAssignment",    
    DeleteAssignmentsForQuery: "Queries/DeleteQueryAssignments",
    GetQueryAssignments: "Queries/GetQueryAssignments",
    GetUserQueries: "Queries/GetUserQueries",
    GetAssignedQueries: "Queries/GetAssignedQueries",
    EntityMetaDataOperators: "EntityMetaDataOperators"
};
